import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { toggleNumbering } from 'roosterjs-editor-api';

const numbering: RibbonButton = {
    key: 'numbering',
    title: () => strings.numbering,
    imageSrc: require('../svg/numbering.svg'),
    imageRtlSrc: require('../svg/numbering-rtl.svg'),
    shortcutWin: 'Ctrl+/',
    shortcutMac: '⌘+/',
    buttonState: formatState =>
        formatState.isNumbering ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleNumbering(plugin.getEditor()),
};

export default numbering;
